/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Choose_AnotherInputs */



/**
* | output |
* | --- |
* | "Choose another file" |
*
* @param {Team_Manager_Import_Choose_AnotherInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_choose_another = /** @type {((inputs?: Team_Manager_Import_Choose_AnotherInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Choose_AnotherInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisir un autre fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Andere Datei wählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli un altro file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбрать другой файл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elegir otro archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择其他文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("別のファイルを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दूसरी फ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolher outro ficheiro")
	return /** @type {LocalizedString} */ ("Choose another file")
});